import * as Keys from '../../keys/keys.json';
let path = require('path');

class Tracker {
    /**
     * Constructor for Google Analytics
     * Constants in the Tracker object should be used for defining events
     * 
     * @constructor
     * @constructs Creates a Google Analytics Event Tracker with specified options
     * @param {object} options - Options for creating the GA Event Tracker
     */
    constructor(options) {
        this.gaService = ga('create', options.trackerId, 'auto');
        this.events = {
            view: 'View',
            drug: 'Drug',
            place: 'Place',
            modal: 'Modal',
            location: 'Location'
        };
        this.actions = {
            home: BASE_URL,
            search: 'Search',
            opened: 'Opened',
            allowed: 'Allowed',
            blocked: 'Blocked',
            error: 'Error'
        };
        this.errors = {
            failedToRetrieve: 'Failed to Get Data',
            dataNotAvailable: 'Data was not available'
        }
    }

    /**
    *   Sends an event in to the Google Analytics global event queue
    *
    *   @param {string} type - Type of hit
    *   @param {function} callback - Callback that will be invoked once the event has finished sending
    *   @param {string} category - Category for the event
    *   @param {string} action - Action designation for the event
    *   @param {string} label - Label for the event
    *   @returns {array} Returns and array that containers the google analytics queue, or an error object
    */
    sendEvent(callback = '', ...args) {
        let hitCallback;
        if (typeof callback === "function") {
                hitCallback = { hitCallback: callback };
            } else {
                hitCallback = { hitCallback: () => {
                    return true;
                }}
            }
        try {  
            ga('send', 'event', ...args, hitCallback);
            return ga.q;
        } catch (err) {
            return new Error(err);
        }
    }

    /**
     * Sends the initial pageview for a user launching the app
     */
    launch() {
        ga('send', 'pageview');
    }
}

export let tracker = new Tracker({ trackerId: Keys.gaTrackerId});


// WEBPACK FOOTER //
// ../D:/builds/ACES/Pharmacy Compass Production Support/PharmacyCompass2/Content/scripts/analytics.js